export default __webpack_public_path__ + "static/media/UserOne.692daef8.svg";